/** `text` — left-aligned single line, ellipsis on overflow (M2 §5.3, §6). */
import { getColumnType } from '@elizmonday/shared';
import { CellText, InlineTextEditor } from '../primitives';
import { defineColumnUi } from '../types';
import { sharedBuckets } from '../buckets';
import { TextSettingsDialog } from './SettingsDialog';

const shared = getColumnType('text');

export const textColumnUi = defineColumnUi<string, Record<string, unknown>>({
  type: 'text',
  icon: 'columnText',
  gallery: { group: 'essentials', keywords: ['text', 'string', 'note', 'sku'] },
  /** P-022: `1802997440` `Organization` (`width: null`) renders **140** px in monday. */
  defaultWidth: 140,
  align: 'left',
  groupable: true,
  /** P-263: the value is item-independent, so it may be written to a whole selection. */
  massEditable: true,

  Cell: ({ value, settings, context }) => (
    <CellText text={shared.toText(value, settings) ?? ''} align="left" search={context.search} />
  ),

  Editor: ({ value, settings, initialInput, autoFocus, onCommit, onCancel, onNavigate }) => (
    <InlineTextEditor
      initial={shared.toText(value, settings) ?? ''}
      initialInput={initialInput}
      autoFocus={autoFocus}
      ariaLabel="Text"
      onCommit={(next) => onCommit(next.trim() === '' ? null : next)}
      onCancel={onCancel}
      onNavigate={onNavigate}
    />
  ),

  SettingsDialog: TextSettingsDialog,

  fromClipboard(text, settings) {
    return shared.parseValue(text, settings) as string | null;
  },
  toClipboard(value, settings) {
    return shared.toText(value, settings) ?? '';
  },
  bucketsOf: sharedBuckets('text'),
});
